import { makeStyles } from 'tss-react/mui';

const useStylesFormError: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  formError: {
    margin: '20px !important',
    color: theme.palette.error.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  formErrorLeftOffset: {
    left: 270,
  },
  formErrorTopOffset: {
    marginTop: '40px !important',
  },
}));

export default useStylesFormError;
